import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from "@angular/router";
import { OrderItem, OrderItemService } from "@app/orders-base";

@Injectable({ providedIn: 'root' })
export class OrderItemResolver implements Resolve<any> {
    /**
     * Constructor
     */
    constructor(private orderItemService: OrderItemService, private router: Router) { }

    /**
     * Resolves order type
     * @param route 
     * @param state 
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let orderItemId = parseInt(route.params['id']);
        if (orderItemId) {
            this.orderItemService.get(orderItemId, { projection: ['orderItemBundle'] }).subscribe((x: OrderItem) => {
                this.router.navigate([`/orders/edit/${x.orderItemBundle.orderId}/bundle`, x.orderItemBundle.id], { replaceUrl: true });
            });
        }
    }
}